(function ($, window, document, undefined) {
	$(function () {
		/**
		 * Date of birth
		 */

		/*
		window.popupAgeV2 = function () {
			function createCookie(name, value, days) {
				let expires = "";
				if (days) {
					const date = new Date();
					date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
					expires = "; expires=" + date.toUTCString();
				}

				document.cookie =
					encodeURIComponent(name) +
					"=" +
					encodeURIComponent(value) +
					expires +
					"; path=/";
			}

			function readCookie(name) {
				let nameEQ = encodeURIComponent(name) + "=";
				let ca = document.cookie.split(";");
				for (let i = 0; i < ca.length; i++) {
					let c = ca[i];
					while (c.charAt(0) === " ") {
						c = c.substring(1);
					}
					if (c.indexOf(nameEQ) === 0) {
						return decodeURIComponent(c.substring(nameEQ.length));
					}
				}
				return null;
			}

			if (readCookie("save-age") !== "yes") {
				$("body").css("overflow", "hidden");
				$(".popup-age-v2").addClass("popup-age_visible");
				$(".btn-adult").on("click", function (e) {
					e.preventDefault();
					createCookie("save-age", "yes", 365);
					$(".popup-age-v2").removeClass("popup-age_visible");
					$("body").css("overflow", "auto");
				});
				$(".btn-no-adult").on("click", function (e) {
					e.preventDefault();
					$(".popup-age-v2 .verification-error").fadeIn(200);
				});
			}
		}
		function dateOfBirth() {
			console.log(dateOfBirth);
		}

		function init() {
			// dateOfBirth();
			// window.popupAgeV2();
		}

		init();*/
	});
})(jQuery, window, document);


/**
 * Age verification popup
 */

/*
window.ageVerificationPopup = function() {
	function createCookie(name, value, days) {
		let expires;

		if (days) {
			let date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toGMTString();
		} else {
			expires = "";
		}

		document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
	}

	// Date picker
	$("#birthdayPicker").birthdayPicker({
		maxAge: 100,
		minAge: 0,
		"dateFormat": "middleEndian",
		"monthFormat": "number",
		"placeholder": true,
		"defaultDate": false,
	});

	$(".age-verification-form").on("submit", function (e) {
		e.preventDefault();

		const $button = $(this).find("button[type='submit']");

		// Clear all validation messages
		const verificationMessages = $(".verification-messages");
		$(verificationMessages).empty();
		$(".age-verification-form").removeClass("age-verification-form_invalid");

		const verificationMonth = parseInt($(".birthMonth").val());
		const verificationDay = parseInt($(".birthDate").val());
		const verificationYear = parseInt($(".birthYear").val());
		const verificationError = $("<p class='verification-error'></p>");

		function isLeapYear(year) {
			const date = new Date(year, 1, 28);
			date.setDate(date.getDate() + 1);
			return date.getMonth() == 1;
		}

		function getAge(date) {
			const birthDate = new Date(date);
			const now = new Date();
			let years = now.getFullYear() - birthDate.getFullYear();

			birthDate.setFullYear(birthDate.getFullYear() + years);

			if (birthDate > now) {
				years--;
				birthDate.setFullYear(birthDate.getFullYear() - 1);
			}
			const days = (now.getTime() - birthDate.getTime()) / (3600 * 24 * 1000);

			return years + days / (isLeapYear(now.getFullYear()) ? 366 : 365);
		}

		let birthDate;

		if (verificationYear && verificationMonth && verificationDay) {
			birthDate = `${verificationYear}-${verificationMonth < 10 ? "0" + verificationMonth : verificationMonth}-${verificationDay < 10 ? "0" + verificationDay : verificationDay}`;
		}

		const age = Math.floor(getAge(birthDate));

		if (isNaN(age)) {
			$(verificationError).text("Please enter your birthdate.");
			$(verificationMessages).append(verificationError);
			$(".age-verification-form").addClass("age-verification-form_invalid");
			return;
		}

		if (age < 21) {
			$(verificationError).text("Sorry! You are not allowed to enter!");
			$(verificationMessages).append(verificationError);
			$(".age-verification-form").addClass("age-verification-form_invalid");
		} else {
			$button.attr("disabled", "disabled");

			if ($("#save-age").is(":checked")) {
				createCookie("save-age", "yes", 365);
			}

			$(".popup_age-verification").removeClass("popup-age_visible");
			$button.removeAttr("disabled");
		}
	});

	const displayPopupHandler = function (event) {
		// Remove event listener if cookie is present. Else show popup.
		if (readCookie("save-age") !== null) {
			$(document).off("click", ".home-hero__button", displayPopupHandler);
		} else {
			if (event) {
				event.preventDefault();
			}
			$(".popup_age-verification").addClass("popup-age_visible");
		}
	}

	function readCookie(name) {
		let nameEQ = encodeURIComponent(name) + "=";
		let ca = document.cookie.split(";");

		for (var i = 0; i < ca.length; i++) {
			let c = ca[i];

			while (c.charAt(0) === " ") {
				c = c.substring(1, c.length);
			}

			if (c.indexOf(nameEQ) === 0) {
				return decodeURIComponent(c.substring(nameEQ.length, c.length));
			}
		}
		return null;
	}

	// Do not display popup if cookie is present
	if (readCookie("save-age") === null) {
		// Show popup
		displayPopupHandler();

		$(document).on("click", ".home-hero__button", displayPopupHandler);
	}

	// Close on click outside
	$(document).on("click", function (e) {
		const target = e.target;

		if ($(target).closest(".popup-age__close").length !== 0) {
			$(".popup_age-verification").removeClass("popup-age_visible");
		}
	});
}
	*/
// $(window).on("load", window.ageVerificationPopup);
